'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridProps = undefined;

var _componentHelpers = require('../../../../utils/component-helpers');

var defaultCellSize = {
  left: ['colXs2', 'colMd2', 'colLg1'],
  right: ['colXs10', 'colMd10', 'colLg11']
};

var gridProps = exports.gridProps = function gridProps() {
  var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments[1];

  return {
    gridStyles: styles.grid,
    styles: styles.hero,
    rows: [props.heroFeatures && {
      content: (props.heroFeatures || []).map(function (feature) {
        return {
          leftCell: (0, _componentHelpers.getIconOrImage)(feature),
          rightCell: (0, _componentHelpers.potentialHtml)((0, _componentHelpers.concactDescStr)(feature.desc)),
          leftCellSize: props.leftCellSize || defaultCellSize.left,
          rightCellSize: props.rightCellSize || defaultCellSize.right
        };
      })
    }, props.heroAnnualFeeLabel && {
      content: [{
        leftCell: props.heroAnnualFeeLabel,
        rightCell: (0, _componentHelpers.potentialHtml)((0, _componentHelpers.concactDescStr)(props.cardAnnualFee)),
        leftCellSize: props.leftCellSize || defaultCellSize.left,
        rightCellSize: props.rightCellSize || defaultCellSize.right
      }]
    }, props.heroSuppAnnualFeeLabel && {
      content: [{
        leftCell: props.heroSuppAnnualFeeLabel,
        rightCell: (0, _componentHelpers.potentialHtml)((0, _componentHelpers.concactDescStr)(props.suppAnnualFee, '<br/>')),
        leftCellSize: props.leftCellSize || defaultCellSize.left,
        rightCellSize: props.rightCellSize || defaultCellSize.right
      }]
    }, props.cardTypeLabel && {
      content: [{
        leftCell: props.cardTypeLabel,
        rightCell: (0, _componentHelpers.potentialHtml)((0, _componentHelpers.concactDescStr)(props.cardType.desc, '<br/>')),
        leftCellSize: props.leftCellSize || defaultCellSize.left,
        rightCellSize: props.rightCellSize || defaultCellSize.right
      }]
    }].filter(function (row) {
      return !!row;
    }),
    title: (0, _componentHelpers.potentialHtml)(props.cardTitle),
    subtitle: (0, _componentHelpers.potentialHtml)((0, _componentHelpers.concactDescStr)(props.cardDesc)),
    welcomeOffer: (0, _componentHelpers.potentialHtml)(props.welcomeOffer)
  };
};